import { FatalAssertInstanceError, Store } from '@rehaje/core'
import { memo, useEffect } from 'react'

import { RecursionView } from './RecursionView'

import type { FC } from 'react'

Store.registerRecursionRender((node) => {
  if (!node.isViewNode()) return <>{node.__r_transpileSlave()}</>
  return <RecursionView key={node.id} node={node} />
})

export interface ViewProps {
  store: Store
}

export const View: FC<ViewProps> = memo(({ store }) => {
  if (!(store instanceof Store)) throw new FatalAssertInstanceError('Store')

  useEffect(() => store.effect(), [store])

  return <RecursionView key={store.node.id} node={store.node} />
})

View.displayName = 'View'
